import React, { useEffect, useState } from 'react'
import CustomizedDialogs from '../../../common/CustomizedDialogs'
import { Box, FormControlLabel, Radio } from '@mui/material'
import '../../../style/modal/TicketSearch.scss'
import TextBox from '../../../common/TextBox'
import MButton from '../../../common/MButton'
import { focusElemnt } from '../../../utils/helpers'
const TicketSearch = (props) => {
    const { open = false, titleText = '', onClose = () => { }, handleLoad = () => { } } = props
    const [selType, setSelType] = useState("P")
    const [value, setValue] = useState('')
    const columnDef = [
        { lable: "PNR", field: "PNR", id: "P" },
        { lable: "Ticket", field: "ticket", id: "T" },
        { lable: "Seat No", field: "seatNo", id: "S" },
        { lable: "Mobile", field: "mobile", id: "M" },
        { lable: "Email", field: "email", id: "E" },
    ]

    useEffect(() => {
        if (open) {
            setTimeout(() => {
                focusElemnt('ticketSearch')
            }, 100)
        }
    }, [open])
    return (
        <CustomizedDialogs
            open={open}
            titleText={titleText}
            width={'auto'}
            height={'auto'}
            onClose={onClose}
            padding={'0px'}
        >
            <Box className='ticketSearch_page'>
                <Box className='radio_section'>
                    {columnDef.map((obj) => (
                        <FormControlLabel value={obj.id} control={<Radio checked={obj.id === selType}

                        />} label={obj.lable} onChange={() => {
                            setSelType(obj.id)
                            setValue('')
                        }}

                        />
                    ))}

                </Box>
                <Box>
                    <TextBox label={'PNR'} type={selType === 'E' || selType === 'S' ? 'text' : 'number'}
                        value={value}
                        id='ticketSearch'
                        onChange={(event) => {
                            setValue(event.target.value)
                        }}
                    />
                </Box>
                <MButton btnName='Load' style={{ width: '100% !important' }} onClick={() => {
                    handleLoad(selType, value)
                }} />
            </Box>
        </CustomizedDialogs>
    )
}

export default TicketSearch